import { Card } from "@/core/components/ui/card";
import { Stack } from "@/core/components/ui/stack";
import { cn } from "@/core/utils/utils";

export const PageContainer = ({
  className,
  ...otherProps
}: React.ComponentProps<typeof Stack>) => (
  <Stack fullWidth className={cn(className)} {...otherProps} />
);

export const PageMainCard = ({
  className,
  calculatedWidth = false,
  ...otherProps
}: React.ComponentProps<typeof Card> & { calculatedWidth?: boolean }) => (
  <Card
    className={cn(
      "flex h-[calc(100vh-180px)] flex-col overflow-hidden rounded-2xl",
      calculatedWidth
        ? "w-[calc(100vw-281px)] min-w-[800px] max-w-[2000px]"
        : "w-full",
      className,
    )}
    {...otherProps}
  />
);

export const PageMainStack = ({
  className,
  ...otherProps
}: React.ComponentProps<typeof Stack>) => (
  <Stack
    fullWidth
    className={cn("h-full overflow-hidden pl-6", className)}
    {...otherProps}
  />
);

export const PageHeaderStack = ({
  ...otherProps
}: React.ComponentProps<typeof Stack>) => (
  <Stack
    direction="row"
    justify="between"
    align="center"
    className="flex-grow-0 py-2 pr-6"
    fullWidth
    {...otherProps}
  />
);
